import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMapPin } from 'react-icons/fi';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">L</span>
              </div>
              <span className="text-xl font-bold">
                ConsulteSeu<span className="text-primary-400">Nome</span>
              </span>
            </Link>
            <p className="text-gray-400 max-w-md">
              Ajudamos você a descobrir se seu nome está negativado e oferece as melhores 
              opções para limpar seu nome rapidamente.
            </p>
          </div>

          {/* Links Úteis */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Nossos Serviços</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Consulta CPF
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Consulta CNPJ
                </Link>
              </li>
              <li>
                <Link to="/negociar" className="text-gray-400 hover:text-primary-400 transition-colors">
                  Negociação Online
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => {
                    const chatBtn = document.querySelector('button[aria-label="Abrir chat"]');
                    if (chatBtn) chatBtn.click();
                    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
                  }}
                  className="text-gray-400 hover:text-primary-400 transition-colors flex items-center gap-2"
                >
                  Suporte Online
                </button>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2 text-gray-400">
                <FiMail />
                <span>contato@Consulteseunome.com.br</span>
              </li>
              <li className="flex items-center space-x-2 text-gray-400">
                <FiMapPin />
                <span>Angra dos Reis, RJ</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 gap-4">
          <p>&copy; {new Date().getFullYear()} ConsulteSeuNome. Todos os direitos reservados.</p>
          <div className="flex gap-6 text-sm">
            <Link to="/termos" className="hover:text-white transition-colors">Termos de Uso</Link>
            <Link to="/privacidade" className="hover:text-white transition-colors">Política de Privacidade</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
